import { NgModule } from '@angular/core';

import { PasskeyLoginComponent } from './passkey-login.component';
import { PasskeyLoginErrorComponent } from './passkey-login-error.component';

@NgModule({
    imports: [],
    declarations: [PasskeyLoginComponent, PasskeyLoginErrorComponent],
    exports: [PasskeyLoginComponent, PasskeyLoginErrorComponent],
})
export class PasskeyLoginModule {}
